import React, { Fragment, useState, useEffect } from "react";
import {
  Col,
  Card,
  CardHeader,
  CardBody,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  Label,
  FormGroup,
  Form,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import DataTable from "react-data-table-component";
import { H3, Btn, Breadcrumbs, H4 } from "../../AbstractElements";
import { Link, useNavigate } from "react-router-dom";
import DatePicker from "react-datepicker";
import {
  getCouponUsageReport,
  getpackageselect,
  packageReport,
} from "../../CommonURL";
import { getDataWithToken, postDataWithToken } from "../../Utils/restUtils";
import { Add } from "../../Constant";
import SearchList from "../../CommonElements/Search";
import Transparentspinner from "../Common/loader/Transparentspinner";
import IndustryFilter from "../Common/Filters/IndustryFilter";
import CompanyFilter from "../Common/Filters/CompanyFilter";

const CouponUsage = () => {
  const style2 = { width: 60, fontSize: 13, padding: 3, marginRight: "10px" };
  const toggleStyle = {
    padding: "10px 20px",
    opacity: "0.8",
    fontSize: "14px",
  };

  const [appliedFilters, setAppliedFilters] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [totalRows, setTotalRows] = useState(0);
  const [packData, setPackData] = useState([]);
  const [isCompany, setIsCompany] = useState("");
  const [searchKeyword, setSearchKeyword] = useState("");
  const [tempSearch, setTempSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const [searchResetKey, setSearchResetKey] = useState(0);
  const [selectedPackage, setSelectedPackage] = useState("");
  const [packageOptions, setPackageOptions] = useState([]);
  const [isIndustry, setIsIndustry] = useState("");
  const [selectedType, setSelectedType] = useState("");
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [dateRange, setDateRange] = useState([
    //   filters.start_date,
    //   filters.end_date,
  ]);
  const [startDate, endDate] = dateRange;
  const navigate = useNavigate();
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  const packageReportColumns = [
    {
      name: <H4>Sl No</H4>,
      selector: (row) => row.Sl,
      sortable: true,
      width: "80px",
      center:true
    },
    {
      name: <H4>Name</H4>,
      selector: (row) => row.Name,
      sortable: true,
    },
    {
      name: <H4>Code</H4>,
      selector: (row) => row.Code,
      sortable: true,
    },
    {
      name: <H4>Type</H4>,
      selector: (row) => row.Type,
      sortable: true,
      wrap: true,
    },
    {
      name: <H4>Discount</H4>,
      selector: (row) => row.Discount,
      sortable: true,
    },

    {
      name: <H4>Used Count</H4>,
      selector: (row) => row.UsedCount,
      sortable: true,
    },

    {
      name: <H4>Total Discount Amount</H4>,
      selector: (row) => row.TotalDiscountAmount,
      sortable: true,
    },
    {
      name: <H4>Status</H4>,
      selector: (row) => row.Status,
      sortable: true,
    },
  ];

  const typeOptions = [
    { value: "cash", label: "Cash" },
    { value: "percentage", label: "Percentage" },
  ];
  useEffect(() => {
    fetchCouponData(1, perPage, {});
  }, []);

  useEffect(() => {
    setSelectedPackage("");
    loadPackages(isIndustry);
  }, [isIndustry]);

  useEffect(() => {
    setIsCompany(null);
  }, [isIndustry]);

  const updateSearchKeyword = (keyword) => {
    setTempSearch(keyword);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    fetchCouponData(page, perPage, appliedFilters);
  };

  const handlePerRowsChange = (newPerPage, page) => {
    setPerPage(newPerPage);
    fetchCouponData(page, newPerPage, appliedFilters);
  };
  const handleFilter = () => {
    const filters = {
      search: tempSearch,
      industry_type_id: isIndustry?.value || "",
      package_id: selectedPackage || "",
      company_id: isCompany?.value || "",
      type: selectedType || "", 
      start_date: startDate ? startDate.toISOString().split("T")[0] : "",
      end_date: endDate ? endDate.toISOString().split("T")[0] : "",
    };

    setAppliedFilters(filters);
    setCurrentPage(1);
    fetchCouponData(1, perPage, filters);
  };

  const loadPackages = async (industryId) => {
    if (!industryId?.value) {
      setPackageOptions([]);
      setSelectedPackage("");
      return;
    }

    try {
      const res = await getDataWithToken(
        `${getpackageselect}?industry_type_id=${industryId.value}`,
      );
      if (res?.status === true && Array.isArray(res?.data)) {
        setPackageOptions(res.data);
      } else {
        setPackageOptions([]);
      }
    } catch (err) {
      setPackageOptions([]);
    }
  };

  const fetchCouponData = async (page = 1, size = perPage, filters = {}) => {
    setLoading(true);

    try {
      const payload = new URLSearchParams({
        page,
        page_length: size,
        search: filters.search || "",
        industry_type_id: filters.industry_type_id || "",
        package_id: filters.package_id || "",
        company_id: filters.company_id || "",
        type: filters.type || "",
        start_date: filters.start_date || "",
        end_date: filters.end_date || "",
      }).toString();

      const res = await getDataWithToken(`${getCouponUsageReport}?${payload}`);

      const formattedData = res.data.data.map((e, index) => ({
        Sl: (page - 1) * size + index + 1,
        Name: e.name,
        TotalDiscountAmount: e.total_discount_amount,
        Status: e.status,
        UsedCount: e.used_count,
        Discount: e.discount,
        Type: e.type,
        Code: e.code,
      }));

      setPackData(formattedData);
      setTotalRows(res.data.total || 0);
    } catch (err) {
      console.log(err);
    }

    setLoading(false);
  };
  const fetchExportData = async () => {
  const query = new URLSearchParams({
    export: "coupon_usage_report",
    search: appliedFilters.search || "",
    industry_type_id: appliedFilters.industry_type_id || "",
    package_id: appliedFilters.package_id || "",
    company_id: appliedFilters.company_id || "",
    type: appliedFilters.type || "",
    start_date: appliedFilters.start_date || "",
    end_date: appliedFilters.end_date || "",
  }).toString();

  const res = await getDataWithToken(
    `${getCouponUsageReport}?${query}`
  );

  return res?.data || [];
};
const exportExcel = async () => {
  setLoading(true);
  try {
    const data = await fetchExportData();

    const formatted = data.map((e, index) => ({
      Sl: index + 1,
      Name: e.name,
      Code: e.code,
      Type: e.type,
      Discount: e.discount,
      UsedCount: e.used_count,
      TotalDiscountAmount: e.total_discount_amount,
      Status: e.status,
    }));

    const ws = XLSX.utils.json_to_sheet(formatted);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Coupon Usage");

    XLSX.writeFile(wb, "coupon_usage_report.xlsx");
  } catch (err) {
    console.log(err);
  }
  setLoading(false);
};
const exportPDF = async () => {
  setLoading(true);
  try {
    const data = await fetchExportData();

    const doc = new jsPDF();

    const rows = data.map((e, index) => [
      index + 1,
      e.name,
      e.code,
      e.type,
      e.discount,
      e.used_count,
      e.total_discount_amount,
      e.status,
    ]);

    autoTable(doc, {
      head: [[
        "Sl",
        "Name",
        "Code",
        "Type",
        "Discount",
        "Used Count",
        "Total Discount",
        "Status",
      ]],
      body: rows,
    });

    doc.save("coupon_usage_report.pdf");
  } catch (err) {
    console.log(err);
  }
  setLoading(false);
};
  return (
    <Fragment>
      {loading && <Transparentspinner />}
      <Breadcrumbs
        mainTitle="Coupon Usage"
        parent="Report"
        title="Coupon Usage"
      />
      <Card>
        <CardHeader className="d-flex justify-content-between align-items-center">
  <H3>Coupon Usage Report</H3>

  <Dropdown isOpen={dropdownOpen} toggle={() => setDropdownOpen(!dropdownOpen)}>
    <DropdownToggle className="btn btn-primary"  color="#fff" style={{ fontSize: '14px', zIndex: 1000 }}>
      Export <i className="icofont icofont-arrow-up"></i>
    </DropdownToggle>

    <DropdownMenu container="body">
      <DropdownItem onClick={exportExcel}>
        <i className="fa fa-file-excel-o me-2"></i> Excel
      </DropdownItem>

      <DropdownItem onClick={exportPDF}>
        <i className="fa fa-file-pdf-o me-2"></i> PDF
      </DropdownItem>
    </DropdownMenu>
  </Dropdown>
</CardHeader>
        <div
          style={{
            paddingLeft: "22px",
            marginRight: "22px",
            marginBottom: "-20px",
          }}
        >
          {/* <div style={{ display: "flex", alignItems: "center", float: "left" }}>
            <SearchList />
            <button className="btn btn-primary  mb-2 ms-2  ">Filter</button>
          </div> */}
          <div className="px-4 pb-2">
            <Row className="g-3 align-items-center">
              <Col sm="12" md="5" lg="3" className="pt-3">
                <SearchList
                  className="form-control"
                  key={searchResetKey}
                  updateSearchKeyword={updateSearchKeyword}
                  // onEnter={handleFilter}
                />
              </Col>
              <Col sm="12" md="6" lg="3">
                <IndustryFilter
                  IsIndustry={isIndustry}
                  setIsIndustry={setIsIndustry}
                />
              </Col>
              <Col sm="12" md="6" lg="3">
                <select
                  className="form-control"
                  value={selectedType}
                  onChange={(e) => setSelectedType(e.target.value)}
                >
                  <option value="">Select Type</option>
                  {typeOptions.map((opt) => (
                    <option key={opt.value} value={opt.value}>
                      {opt.label}
                    </option>
                  ))}
                </select>
              </Col>
              <Col sm="12" md="5" lg="3">
                <div style={{ position: "relative" }}>
                  <DatePicker
                    className="form-control digits w-100"
                    selectsRange
                    startDate={startDate}
                    endDate={endDate}
                    onChange={(update) => setDateRange(update)}
                    isClearable={!!(startDate || endDate)}
                    monthsShown={2}
                    calendarClassName="parallel-calendar"
                    placeholderText="Select Date Range"
                    dateFormat="dd-MM-yyyy"
                  />
                </div>
              </Col>
              <Col>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    float: "left",
                    gap: "10px",
                  }}
                >
                  <button
                    className="btn btn-primary mb-2 ms-2"
                    onClick={handleFilter}
                  >
                    Filter
                  </button>
                </div>
              </Col>
            </Row>
          </div>
          {/* <div style={{ float: "right" }}>
            <Link
              to={`${process.env.PUBLIC_URL}/configuration/account-add`}
              className="btn btn-primary"
            >
              {Add}
            </Link>
          </div> */}
          <div style={{ clear: "both" }}></div>
        </div>
        <CardBody>
          <div className="order-history table-responsive">
            <DataTable
              columns={packageReportColumns}
              data={packData}
              pagination
              paginationServer
              paginationTotalRows={totalRows}
              paginationDefaultPage={currentPage}
              onChangePage={handlePageChange}
              onChangeRowsPerPage={handlePerRowsChange}
              paginationRowsPerPageOptions={[10, 25, 50, 100]}
            />
          </div>
        </CardBody>
      </Card>
    </Fragment>
  );
};

export default CouponUsage;
